function InfoIcon()
{
    return(
        <svg width="100%" height="100%" viewBox="0 0 24 24">

<g>

<g>

<g>

<circle cx="12" cy="12" fill="none" r="10" stroke="#fffafaff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>

<line fill="none" stroke="#ffffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" x1="12" x2="12" y1="12" y2="16"/>

<line fill="none" stroke="#ffffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" x1="12" x2="12" y1="8" y2="8"/>

</g>

</g>

</g>

</svg>
    )
}

export default InfoIcon